import { SiAndroid, SiApple } from "react-icons/si";
import type { IconType } from "react-icons";

import type { Device } from "@/types/device";

interface PlatformMeta {
  label: string;
  Icon: IconType;
  iconLabel: string;
}

/**
 * Single source of truth for platform labels and icons. Typed as a Record over
 * Device["platform"] so a new platform is a compile error here instead of
 * silently rendering as Android.
 */
const PLATFORM_META: Record<Device["platform"], PlatformMeta> = {
  ios: { label: "iOS", Icon: SiApple, iconLabel: "Apple device" },
  android: { label: "Android", Icon: SiAndroid, iconLabel: "Android device" },
  watchos: { label: "watchOS", Icon: SiApple, iconLabel: "Apple Watch device" },
};

export function getPlatformLabel(platform: Device["platform"]): string {
  return PLATFORM_META[platform].label;
}

interface PlatformIconProps {
  platform: Device["platform"];
  className?: string;
}

export function PlatformIcon({ platform, className }: PlatformIconProps) {
  const { Icon, iconLabel } = PLATFORM_META[platform];
  return <Icon className={className} aria-label={iconLabel} />;
}